import { Typography } from "@mui/material";
import { LabelWithIcon } from "./label-with-icon";
import { LabelAndValue } from "./label-and-value";

function AppLabel({ label, ...props }) {
  return (
    <Typography variant="medium-bold" {...props}>
      {label}
    </Typography>
  );
}

function AppValue({ value, component, children, ...props }: any) {
  switch (component) {
    default:
      return (
        <Typography variant="medium" color={"text.secondary"} {...props}>
          {value ? value : children}
        </Typography>
      );
  }
}

export { AppLabel, LabelAndValue, LabelWithIcon, AppValue };
export { ClampedTextReadMore } from "./ClampedTextReadMore";
